import * as NetWorthDonutChartActions from '../NetWorthDonutChart/NetWorthDonutChartActions';

export const RECEIVE_DATA = 'C_BALANCESHEET.RECEIVE_DATA';
export const SET_ERRORS = 'C_BALANCESHEET.SET_ERRORS';

export const receive_data = (owners, resp_data, clientId, promise_awaiting) => ({
  type: RECEIVE_DATA,
  owners,
  resp_data,
  clientId,
  promise_awaiting,
});

export const set_errors = (errors, clientId) => ({
  type: SET_ERRORS,
  errors,
  clientId,
});

export const remove_owner = (owners, owner, clientId) => {
  return dispatch => {
    const local_owners = owners.slice();
    local_owners.splice(local_owners.indexOf(owner), 1);
    dispatch(fetch_data(local_owners, clientId));
  };
};

export const fetch_data = (Owners, clientId) => {
  if (!clientId) return {};
  return dispatch => {
    ADV.util
      .request(
        {
          uri: 'Consumer/BalanceSheetView',
          data: {
            Owners,
            clientId,
          },
          sendStringifyJSON: true,
          showSpinner: true,
        },
        true,
      )
      .then(resp => {
        if (resp.success) {
          dispatch(
            receive_data(
              Owners || resp.payload.viewData.OwnerOptions.slice(),
              resp.payload.viewData,
              clientId,
            ),
          );
          dispatch(NetWorthDonutChartActions.receive_data(null, resp.payload.viewData, clientId));
        } else {
          dispatch(set_errors(resp.errors, clientId));
        }
      });
  };
};

// Expose receive_data, set_errors to HM
window.ADV.store_functions = window.ADV.store_functions
  ? Object.assign({}, window.ADV.store_functions, {
      balance_sheet_receive_data: receive_data,
      balance_sheet_set_errors: set_errors,
    })
  : {
      balance_sheet_receive_data: receive_data,
      balance_sheet_set_errors: set_errors,
    };
